import { NavLink } from 'react-router-dom';
import type { DestinoNav } from './navItems';

interface Props {
  destinos: DestinoNav[];
  colapsado?: boolean;
  onNavigate?: () => void;
}

export function SidebarNav({ destinos, colapsado, onNavigate }: Props) {
  return (
    <nav className="flex flex-col gap-1 px-2">
      {destinos.map((d) => (
        <NavLink
          key={d.to}
          to={d.to}
          end={d.fin}
          onClick={onNavigate}
          title={colapsado ? d.etiqueta : undefined}
          className={({ isActive }) =>
            [
              'flex items-center gap-3 rounded-full px-3 py-2.5 text-sm font-medium transition active:scale-[0.98]',
              isActive ? 'bg-white/10 text-oro' : 'text-white/70 hover:bg-white/5 hover:text-oro',
              colapsado ? 'justify-center px-0' : '',
            ].join(' ')
          }
        >
          <d.Icono className="h-5 w-5 shrink-0" />
          {!colapsado && <span className="truncate">{d.etiqueta}</span>}
        </NavLink>
      ))}
    </nav>
  );
}
